/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { call, put, takeLatest } from 'redux-saga/effects';
import request from 'modules/common/utils/request';
import { scenarioActions } from './slice';
import API from './constants';
/**
 * Power BI scenario generator function to obtain registered scenarios
 * @param {*} param0
 */
export function* getScenariosGenerator({ payload }) {
  try {
    const response = yield call(request, API.GET_SCENARIOS, payload);
    yield put(scenarioActions.getScenariosSucceeded(response));
  } catch (error) {
    yield put(scenarioActions.getScenariosFailed(error?.message));
  }
}
/**
 * Scenario generator function to create scenario
 * @param {*} param0
 */
export function* createScenarioGenerator({ payload }) {
  try {
    const response = yield call(request, API.POST_SCENARIOS, payload);
    yield put(scenarioActions.createScenariosSucceeded(response));
  } catch (error) {
    yield put(scenarioActions.createScenariosFailed(error?.message));
  }
}
/**
 * Delete scenario generator function to delete scenario
 * @param {*} param0
 */
export function* deleteScenarioGenerator({ payload }) {
  try {
    const response = yield call(request, API.DELETE_SCENARIO, payload);
    yield put(scenarioActions.deleteScenarioSucceeded({ response, data: payload }));
  } catch (error) {
    yield put(scenarioActions.deleteScenarioFailed(error?.message));
  }
}
/**
 * Update scenario generator function to update scenario
 * @param {*} param0
 */
export function* updateScenarioGenerator({ payload }) {
  try {
    const response = yield call(request, API.PATCH_SCENARIO, payload);
    yield put(scenarioActions.updateScenarioSucceeded(response));
  } catch (error) {
    yield put(scenarioActions.updateScenarioFailed(error?.message));
  }
}
/**
 * Get scenario generator function to get scenario by id
 * @param {*} param0
 */
export function* getScenarioByIdGenerator({ payload }) {
  try {
    const response = yield call(request, API.GET_SCENARIO_BY_ID, payload);
    yield put(scenarioActions.getScenarioByIdSucceeded(response));
  } catch (error) {
    yield put(scenarioActions.getScenarioByIdFailed(error?.message));
  }
}
/**
 * Power BI visual generator function to obtain registered visuals
 * @param {*} param0
 */
export function* getVisualsGenerator({ payload }) {
  try {
    const response = yield call(request, API.GET_VISUALS, payload);
    yield put(scenarioActions.getVisualsSucceeded(response));
  } catch (error) {
    yield put(scenarioActions.getVisualsFailed(error?.message));
  }
}
/**
 * Power BI visual filter generator function to obtain registered visual filters
 * @param {*} param0
 */
export function* getVisualFiltersGenerator({ payload }) {
  try {
    const response = yield call(request, API.GET_VISUAL_FILTERS, payload);
    yield put(scenarioActions.getVisualFiltersSucceeded(response));
  } catch (error) {
    yield put(scenarioActions.getVisualFiltersFailed(error?.message));
  }
}
/**
 * Breakdown data generator function to obtain data for breakdown dropdown
 * @param {*} param0
 */
export function* getBreakdownGenerator({ payload }) {
  try {
    const response = yield call(request, API.GET_ALL_BREAKDOWNS, payload);
    yield put(scenarioActions.getBreakdownSucceeded(response));
  } catch (error) {
    yield put(scenarioActions.getBreakdownFailed(error?.message));
  }
}
/**
 * All hotels force fetch generator function to obtain the list of all registered hotels
 * @param {*} param0
 */
export function* getAllHotelsListGenerator({ payload }) {
  try {
    const response = yield call(request, API.GET_ALL_HOTELS, payload);
    yield put(scenarioActions.getAllHotelListSucceeded(response));
  } catch (error) {
    yield put(scenarioActions.getAllHotelListFailed(error?.message));
  }
}
//
export function* scenarioSaga() {
  yield takeLatest(scenarioActions.getScenarios.type, getScenariosGenerator);
  yield takeLatest(scenarioActions.createScenarios.type, createScenarioGenerator);
  yield takeLatest(scenarioActions.deleteScenario.type, deleteScenarioGenerator);
  yield takeLatest(scenarioActions.updateScenario.type, updateScenarioGenerator);
  yield takeLatest(scenarioActions.getScenarioById.type, getScenarioByIdGenerator);
  yield takeLatest(scenarioActions.getVisuals.type, getVisualsGenerator);
  yield takeLatest(scenarioActions.getVisualFilters.type, getVisualFiltersGenerator);
  yield takeLatest(scenarioActions.getBreakdown.type, getBreakdownGenerator);
  yield takeLatest(scenarioActions.getAllHotelList.type, getAllHotelsListGenerator);
}
//
export default scenarioSaga;
